const Phone = ({ className, width = '14', height = '14' }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width={width} height={height} rx="2" fill="#F9F9F9" />
    <path
      d="M14.4937 18.2691L16.5983 16.1645L20.0763 18.5902L19.2961 19.3704C18.7764 19.8901 18.0136 20.0829 17.3094 19.8725C15.1566 19.2294 13.2227 18.0503 11.5077 16.3353C9.79265 14.6203 8.61359 12.6864 7.97046 10.5336C7.76008 9.82943 7.95288 9.0666 8.47255 8.54692L9.25275 7.76672L11.6785 11.2447L9.5739 13.3493"
      stroke="#3C3C3B"
      strokeWidth="0.8"
      strokeLinecap="round"
    />
  </svg>
);

export default Phone;
